import config from 'config'
import Raven from 'raven-js'

const RAVEN_OPTS = Object.freeze({
  ignoreErrors: [
    'TypeError: Network request failed',
      'ajax error 404',
      'ajax error 403',
      'ajax error 401',
      'ajax error 0',
  ]
})

export const initializeSentry = () => {
  Raven.config(config.SENTRY_ID, RAVEN_OPTS).install()
}

export const logError = (error, info = {}, ravenData = {}) => {
  if (!(error instanceof Error)) {
    error = new Error(JSON.stringify(error))
  }

  Raven.captureException(error, { errorInfo: info, ...ravenData, level: 'error' })
}


// WEBPACK FOOTER //
// ./src/utils/logger.js